import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled(Form)``;
